import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'
// const MAIN_DATA = '/sps/mp/historyInfo'

/**
 * 获取用餐数据
 */
const getDinnerData = (data) => {
  return fetch({
    url: `${shop_url}/shop/mp/customer/census/${data.companyId}/${data.page}/${data.size}?start=${data.start}&end=${data.end}`,
    method: 'get'
  })
}
/**
 * 查询用餐数据
 */
const searchDinnerData = (data) => {
  let url = ''
  if (data.tag == null) {
    url = `${shop_url}/shop/mp/customer/census/${data.companyId}/${data.page}/${data.size}?start=${data.start}&end=${data.end}`
  } else {
    url = `${shop_url}/shop/mp/customer/census/${data.companyId}/${data.page}/${data.size}?start=${data.start}&end=${data.end}&tag=${data.tag}`
  }
  return fetch({
    url,
    method: 'get'
  })
}
/**
 * 获取标签数据
 */
const getTagData = (data) => {
  return fetch({
    url: `${shop_url}/shop/mp/tag/${data.companyId}`,
    method: 'get'
  })
}
/**
 * 获取表格数据
 */
const getTableData = (data) => {
  return fetch({
    url: `${shop_url}/shop/mp/customer/census/print`,
    method: 'post'
  })
}

export {
  getDinnerData,
  getTagData,
  getTableData,
  searchDinnerData
}



// WEBPACK FOOTER //
// ./src/api/dinner/index.js